import React, { useState } from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import Arrow from '../pages/Arrow';
import Generalsidebar from '../pages/Generalsidebar';
import { Link } from 'react-router-dom';

const MainResources = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div className='bg-[#DCAE96] m-12 py-5 rounded-3xl'>
        <h1 className='text-3xl text-[#295700] font-serif font-bold py-5 text-center pb-4'>
          RESOUCRCES
        </h1>
        <h5 className='text-2xl text-[#295700] font-serif font-semibold text-center pb-8 italic'>
          THRIVE... Your Source for Essential Resources
        </h5>

        <div className='grid gap-8 justify-items-center md:w-[70%] md:mx-auto grid-cols-3 mt-3 mb-10 mx-2'>
          <Link
            to='/mainarticle'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701905155/book-library-with-open-textbook_lnm2ku.jpg')] bg-contain h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl px-6 py-8 "></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              EDUCATIONAL <br />
              MATERIALS / ARTICLES
              <i className='fa-solid fa-folder' style={{ color: '#295700' }} />
            </p>
          </Link>

          <Link
            to='/videomain'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701908767/11060538_47438_nh1syp.jpg')] bg-cover h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl py-8"></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              VIDEOS
              <span className='pl-8'>
                <i className='fa-solid fa-video' style={{ color: '#295700' }} />
              </span>
            </p>
          </Link>
          <Link
            to='/mainaudiopage'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701905154/vinyl-record-with-retro-texture-composition_elebci.jpg')] bg-cover h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl py-8"></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              AUDIOS
              <span className='pl-8'>
                <i
                  className='fa-solid fa-headphones'
                  style={{ color: '#295700' }}
                />
              </span>
            </p>
          </Link>
          <Link
            to='/relaxation1'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701907161/portrait-beautiful-young-asian-woman-happy-smile-relax-around-neary-beach-sea_z1xng2.jpg')] bg-contain h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl py-8"></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              RELAXATION
            </p>
          </Link>
          <Link
            to='/riddles'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701906408/businesswoman-standing-thinking-near-big-question-mark-isolated-white-background_s1lxup.jpg')] bg-cover h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl py-8"></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              RIDDLES
              <span className='pl-8'>
                <i
                  className='fa-regular fa-circle-question'
                  style={{ color: '#205700' }}
                />
              </span>
            </p>
          </Link>
          <Link
            to='/jokes'
            className='w-5/6 mx-auto md:w-full hover:scale-110 transition-transform duration-300'>
            <div className="bg-[url('https://res.cloudinary.com/dzqx4v0al/image/upload/v1701907162/world-smile-day-emojis_y6tyys.jpg')] bg-cover h-[165px] drop-shadow-xl flex items-center justify-center text-center rounded-xl py-8"></div>
            <p className='text-lg font-semibold text-[#295700] text-center mt-3'>
              JOKES
              <span className='pl-8'>
                <i className='fa-solid fa-face-laugh-beam' />
              </span>
            </p>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainResources;
